import { render, staticRenderFns } from "./CmgShimmer.vue?vue&type=template&id=e72681aa&scoped=true&lang=pug"
import script from "./cmg-shimmer.ts?vue&type=script&lang=ts&external"
export * from "./cmg-shimmer.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgShimmer.vue?vue&type=style&index=0&id=e72681aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72681aa",
  null
  
)

export default component.exports